import { ISpecialPackageDto } from '../model';

function hasText(value?: string | null): value is string {
  return value !== null && value !== undefined && value.trim().length > 0;
}

function isGermanLanguage(language?: string | null): boolean {
  return (language ?? '').toLowerCase().startsWith('de');
}

export function getSpecialPackageTitle(
  specialPackage: Pick<ISpecialPackageDto, 'titleDe' | 'titleEn'>,
  language?: string | null
): string {
  const primary = isGermanLanguage(language)
    ? specialPackage.titleDe
    : specialPackage.titleEn;
  const fallback = isGermanLanguage(language)
    ? specialPackage.titleEn
    : specialPackage.titleDe;

  if (hasText(primary)) {
    return primary;
  }

  if (hasText(fallback)) {
    return fallback;
  }

  return primary || fallback || '';
}

export function getSpecialPackageDescription(
  specialPackage: Pick<
    ISpecialPackageDto,
    'descriptionDe' | 'descriptionEn'
  >,
  language?: string | null
): string | null {
  const primary = isGermanLanguage(language)
    ? specialPackage.descriptionDe
    : specialPackage.descriptionEn;
  const fallback = isGermanLanguage(language)
    ? specialPackage.descriptionEn
    : specialPackage.descriptionDe;

  if (hasText(primary)) {
    return primary;
  }

  if (hasText(fallback)) {
    return fallback;
  }

  return primary ?? fallback ?? null;
}
